import React, { useState } from "react";
import { Container } from "../Styles/Global.Styled";
import ResetPasswordForm from "../Forms/ResetPasswordForm/ResetPasswordForm";
import useToast from "../hooks/useToast";
import { Toast } from "../Components/Toast/Toast";
import LoginForm from "../Forms/LoginForm/LoginForm";
import { css } from "styled-components";

const flexDStyle = css`
  flex-direction: column;
`;

const Login = ({ setPopUp }) => {
  const [formType, setFormType] = useState(0);
  const { toast, showToast, hideToast } = useToast();

  return (
    <Container $baseStyle={flexDStyle}>
      {!toast.hidden && (
        <Toast
          message={toast.text}
          title={toast.title}
          type={toast.type}
          height={"5vh"}
          hideToast={hideToast}
        />
      )}
      {formType === 0 ? (
        <LoginForm
          showToast={showToast}
          setFormType={setFormType}
          setPopUp={setPopUp}
        />
      ) : formType === 1 ? (
        <ResetPasswordForm showToast={showToast} setFormType={setFormType} />
      ) : null}
    </Container>
  );
};

export default Login;
